import { Star } from "lucide-react";
import { motion } from "framer-motion";

const reviews = [
  {
    name: "Tobias D.",
    role: "Privatumzug in Augsburg",
    date: "02/2026",
    text: "Einfach nur gut. Innerhalb von 4 Stunden war der komplette Umzug erledigt. Schnell, effizient und sicher!!",
    rating: 5,
  },
  {
    name: "Melisa C.",
    role: "Möbelmontage in München",
    date: "01/2026",
    text: "Die Jungs waren top. Großer Kleiderschrank wurde in Rekordzeit aufgebaut. Danke und immer wieder gerne ☺️👍🏼",
    rating: 5,
  },
  {
    name: "Gabriele Schiffers",
    role: "Firmenumzug in Ulm",
    date: "12/2025",
    text: "Trotz widriger Umstände unsererseits reibungsloser Ablauf, freundliche Männer, haben sorgfältig und kraftvoll gearbeitet. Absoluter Festpreis ohne Nachverhandlungen. Der Preis passt auch. Kann ich gerne weiterempfehlen!",
    rating: 5,
  },
  {
    name: "Erik A.",
    role: "Umzug nach Ingolstadt",
    date: "11/2025",
    text: "Sehr guter Service, 0 Schäden an unseren empfindlichen Möbeln. Jederzeit wieder!",
    rating: 5,
  },
  {
    name: "Jenny Brauer",
    role: "Privatumzug in Landsberg",
    date: "10/2025",
    text: "Ich war wirklich sehr zufrieden. Die Jungs waren schnell, zuverlässig, preislich sehr fair, freundlich und es ist nichts kaputt gegangen. Volle 5 Sterne!",
    rating: 5,
  },
  {
    name: "Veronika Schollmeyer",
    role: "Seniorenumzug in Augsburg",
    date: "09/2025",
    text: "Andriy und sein Team waren außerordentlich zuverlässig und einfach super. Wir waren mega zufrieden. Preis-Leistung tipptopp und auch wirklich alles andere 1A. Der Festpreis wurde exakt eingehalten.",
    rating: 5,
  }
];

const Testimonials = () => {
  return (
    <section className="py-20 bg-neutral-100 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-12 text-center"
        >
          <span className="font-semibold text-primary uppercase tracking-wider text-sm">Kundenstimmen</span>
          <h2 className="font-heading text-3xl md:text-5xl mt-2">Was unsere Kunden über uns sagen</h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((review, index) => (
            <motion.div 
              key={index} 
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-white p-8 border border-neutral-200 shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="flex gap-1 text-[#fabb05]">
                  {[...Array(review.rating)].map((_, i) => (
                    <Star key={i} size={20} fill="currentColor" />
                  ))}
                </div>
                <span className="text-sm text-neutral-400 font-medium">{review.date}</span>
              </div>
              <p className="text-neutral-600 font-medium mb-6 italic leading-relaxed">
                "{review.text}"
              </p>
              <a href="https://share.google/xw8JE3IKl3tC9Kcw0" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between mt-auto hover:opacity-80 transition-opacity">
                <div>
                  <span className="font-heading text-lg block">{review.name}</span>
                  <span className="text-sm text-neutral-500">{review.role}</span>
                </div>
                <img src="https://storage.googleapis.com/revex-reputation-production/assets/google-icon.svg" alt="Google Review" width="24" height="24" loading="lazy" decoding="async" className="w-6 h-6" />
              </a>
            </motion.div>
          ))}
        </div>

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-12 text-center"
        >
          <a 
            href="https://share.google/xw8JE3IKl3tC9Kcw0" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-white text-neutral-900 border border-neutral-200 shadow-sm hover:bg-neutral-50 px-6 py-3 font-semibold rounded-lg transition-colors"
          >
            <img src="https://storage.googleapis.com/revex-reputation-production/assets/google-icon.svg" alt="Google" width="20" height="20" loading="lazy" decoding="async" className="w-5 h-5" />
            Alle Bewertungen auf Google ansehen
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;